export default "__VITE_ASSET__DgoVkrB7__"